export default __webpack_public_path__ + "static/media/restaurant-5-rMAX.df56af13.jpg";